/* Organise existing merchant-authored product HTML without rewriting or duplicating its contents. */
(() => {
  function init(root) {
    if (root.dataset.kpReady === '1') return;
    const original = root.querySelector('[data-kp-original]');
    const intro = root.querySelector('.kp-intro');
    const panels = root.querySelector('[data-kp-accordions]');
    if (!original || !intro || !panels) return;
    const nodes = Array.from(original.children);
    if (!nodes.length) return;
    const groups = [];
    let group = {key: 'intro',title: 'About this piece',nodes: []};
    groups.push(group);
    const headingKey = v => {
      const s = v.replace(/\s+/g,' ').trim().toUpperCase();
      if (s === 'SIZE CHART' || s === 'SIZE GUIDE') return 'size';
      if (s === 'PRODUCT DETAILS') return 'details';
      if (s === 'COMPOSITION') return 'composition';
      if (s === 'CARE' || s === 'CARE INSTRUCTIONS') return 'care';
      if (s === 'ORIGIN') return 'origin';
      return null;
    };
    nodes.forEach(node => {
      const h = /^H[2-5]$/.test(node.tagName) ? headingKey(node.textContent || '') : null;
      if (h) {
        group = {key: h, title: node.textContent.trim(), nodes: []};
        groups.push(group);
        node.remove();
      } else {
        group.nodes.push(node);
      }
    });
    let rendered = 0;
    groups.forEach(g => {
      if (!g.nodes.length) return;
      if (g.key === 'intro') {
        g.nodes.forEach(node => intro.appendChild(node));
        return;
      }
      const detail = document.createElement('details');
      detail.className = 'kp-panel';
      if (g.key === 'size') {
        detail.id = original.id;
        original.removeAttribute('id');
        detail.open = true;
      }
      const summary = document.createElement('summary');
      summary.textContent = g.key === 'size' ? 'SIZE CHART & FIT' : g.title;
      const body = document.createElement('div');
      body.className = 'kp-panel__content';
      g.nodes.forEach(node => {
        if (node.tagName === 'TABLE') {
          const scroller = document.createElement('div');
          scroller.className = 'kp-table-scroll';
          scroller.setAttribute('tabindex','0');
          scroller.setAttribute('role','region');
          scroller.setAttribute('aria-label','Garment size measurements; scroll horizontally for more columns');
          scroller.appendChild(node);
          body.appendChild(scroller);
        } else {
          body.appendChild(node);
        }
      });
      detail.append(summary, body);
      panels.appendChild(detail);
      rendered++;
    });
    if (rendered && !original.children.length) original.remove();
    root.dataset.kpReady='1';
  }
  function boot() {
    document.querySelectorAll('[data-kp-product-info]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
  document.addEventListener('shopify:section:load',boot);
  document.addEventListener('click',e=>{
    const link = e.target.closest('[data-kp-size-link]');
    if (!link) return;
    const hash = link.getAttribute('href');
    if (!hash || hash[0] !== '#') return;
    const row = document.getElementById(hash.slice(1));
    if (row && row.tagName === 'DETAILS') row.open=true;
  });
})();
